import { ActivatedRoute, Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-payment-status-dialog',
  templateUrl: './payment-status-dialog.component.html',
  styleUrls: ['./payment-status-dialog.component.css']
})
export class PaymentStatusDialogComponent implements OnInit {
  color: 'accent' | 'warn' | undefined;
  icon: 'check_circle' | 'error_outline' | undefined;
  orderId: string= "";
  order_tx_number: string = "";
  constructor(
    private loadingService: LoadingService,
    private api: ApiService,
    private route: ActivatedRoute,
    private dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      texts: string[],
      pay: boolean,
      order_id: string,
      order_tx_number: string
    }
  ) {
    this.orderId = this.data?.order_id || this.route.snapshot.queryParams['id'];
    this.order_tx_number = this.data?.order_tx_number || "";

   }

  ngOnInit(): void {
    if (this.data.pay) {
      this.color = 'accent';
      this.icon = 'check_circle';
    } else {
      this.color = 'warn';
      this.icon = 'error_outline';
    }
  }

   downloadTickets(): void {
    this.loadingService._setLoading();
        this.dialog.closeAll();

    this.api.downloadOrderTickets(this.orderId)
      .subscribe({
        next: response => {
          if (!response || response.constructor != Blob) {
            return;
          }

          this.saveFile(response, this.order_tx_number +'-ticket', 'pdf');
          this.loadingService._clearLoading();
        },
        error: error => {
          this.loadingService._clearLoading();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }

  saveFile(blob: Blob, filename: string, ext?: string): void {
    const downloader = document.createElement('a');
    const url = URL.createObjectURL(blob);
    downloader.href = url;
    downloader.download = filename + (ext ? '.' + ext : '');
    downloader.click();
    URL.revokeObjectURL(url);
    downloader.remove();
  }

}
